import { Button, ButtonGroup, Card, Grid, Hidden } from '@material-ui/core';
import { useContext } from 'react';
import { EWIPDashboardScreenContext } from '../DashboardProvider';
import { WipNoRecord, WipScreenLoader } from './wipDash-Loader';

export const WipDashboardStatus = ({ classes, HandleStatusLink }) => {
    const { state, array, handleStatusFren, handleChangeByTime } = useContext(EWIPDashboardScreenContext);
    return state.showHeaderLoader ? (
        <div className="wip-dash-Card">
            <WipScreenLoader />
        </div>
    ) : (
        <Card className="wip-dash-Card">
            <Hidden only={['xs']}>
                <Grid container justifyContent="space-between">
                    <Grid item xs={12} sm="auto">
                        <div
                            style={{
                                width: '100%',
                                textAlign: 'left',
                                color: '#f50057',
                                fontWeight: 600,
                                margin: '10px 20px'
                                // backgroundColor: 'red'
                            }}
                        >
                            <ButtonGroup color="secondary" ria-label="outlined primary button group" size="small">
                                <Button
                                    variant={array.franchise === 'All' ? 'contained' : 'outlined'}
                                    onClick={() => handleStatusFren('All')}
                                    style={{ fontSize: 10 }}
                                >
                                    All&nbsp;&nbsp;<b>({array.statusBranchTotal})</b>
                                </Button>

                                {array.franchiseArray.map((n, i) => {
                                    return (
                                        <Button
                                            fullWidth
                                            key={i}
                                            variant={array.franchise === n.name ? 'contained' : 'outlined'}
                                            onClick={() => handleStatusFren(n.name)}
                                            style={{ fontSize: 10 }}
                                        >
                                            {n.name} &nbsp;&nbsp;<b>({n.total})</b>
                                        </Button>
                                    );
                                })}
                            </ButtonGroup>
                        </div>
                    </Grid>
                    <Grid item xs={12} sm>
                        <div style={{ float: 'right', marginRight: 40, display: 'flex' }}>
                            <div
                                style={{
                                    padding: '2px 12px 0px 0px',
                                    fontSize: 20,
                                    fontWeight: 600,
                                    cursor: 'pointer'
                                }}
                                onClick={() =>
                                    HandleStatusLink(
                                        {
                                            bn: array.byTimeBranch,
                                            isTotal: true
                                        },
                                        true
                                    )
                                }
                            >
                                <span>Total : {array.statusBranchTotal}</span>
                            </div>{' '}
                            <div>
                                <select onChange={handleChangeByTime} className="selectclass" value={array.byTimeBranch}>
                                    <option value={'Default'}>All Branches</option>
                                    {state.chartdata.map((btn, i) => {
                                        return (
                                            <option key={i} value={btn.name}>
                                                {btn.name}{' '}
                                            </option>
                                        );
                                    })}
                                </select>
                            </div>
                        </div>
                    </Grid>
                </Grid>
            </Hidden>
            <Hidden only={['sm', 'md', 'lg', 'xl']}>
                <Grid container justifyContent="space-between" spacing={0}>
                    <Grid item xs={12} sm={6}>
                        <div
                            style={{
                                margin: '0px 20px',
                                textAlign: 'left'
                            }}
                        >
                            <span className="lableFont">Franchise</span>
                            <select
                                color="secondary"
                                onChange={handleStatusFren}
                                aria-label="outlined primary button group"
                                size="small"
                                className="ButtonDropDown"
                                value={array.franchise}
                            >
                                {array.franchiseArray.map((n, i) => {
                                    return (
                                        <option key={i} value={n.id}>
                                            {n.name}
                                        </option>
                                    );
                                })}
                            </select>
                        </div>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <div style={{ margin: '0px 20px', textAlign: 'left' }}>
                            <span className="lableFont">Branch</span>
                            <select onChange={handleChangeByTime} className="selectclass" value={array.byTimeBranch}>
                                <option value={'Default'}>All Branches</option>
                                {state.chartdata.map((btn, i) => {
                                    return (
                                        <option key={i} value={btn.name}>
                                            {btn.name}{' '}
                                        </option>
                                    );
                                })}
                            </select>
                        </div>
                    </Grid>
                </Grid>
            </Hidden>

            <div style={{ padding: '0px 30px' }}>
                <hr className="labeled-bordered-box" />
            </div>
            <Grid container spacing={0} style={{ padding: '0px 20px' }} justifyContent="flex-start">
                {array.StatusList?.length === 0 ? (
                    <WipNoRecord />
                ) : (
                    array.StatusList.map((g, i) => {
                        const { franchise, jobs, status, branchID } = g;

                        if (array.franchise === franchise) {
                            return (
                                <div
                                    key={i}
                                    style={{ cursor: 'pointer' }}
                                    onClick={() =>
                                        HandleStatusLink(
                                            {
                                                fr: array.franchise,
                                                status: status,
                                                bn: array.byTimeBranch
                                            },
                                            true
                                        )
                                    }
                                >
                                    <Grid item style={{ padding: '5px 0px' }}>
                                        <div style={{ borderLeft: '5px solid #88EBA4' }} className="wip-dash-Card-content">
                                            <div className="wip-dash-Card-content-values">
                                                <span className="lableFont">{status}</span>
                                                <div className="valueFont">{jobs}</div>
                                            </div>
                                        </div>
                                    </Grid>
                                </div>
                            );
                        } else {
                            <div
                                key={i}
                                style={{ cursor: 'pointer' }}
                                onClick={() =>
                                    HandleStatusLink(
                                        {
                                            fr: '',
                                            status: '',
                                            bn: ''
                                        },
                                        true
                                    )
                                }
                            >
                                <Grid item style={{ padding: '5px 0px' }}>
                                    <div style={{ borderLeft: '5px solid #88EBA4' }} className="wip-dash-Card-content">
                                        <div className="wip-dash-Card-content-values">
                                            <span className="lableFont">{status}</span>
                                            <div className="valueFont">{jobs}</div>
                                        </div>
                                    </div>
                                </Grid>
                            </div>;
                        }
                    })
                )}
            </Grid>
        </Card>
    );
};
